var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container details-container"},[(_vm.subject==='xcb')?[_c('xcb',{attrs:{"activity":_vm.activity,"subject":_vm.subject}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }